<template>
  <div style="margin-left: 30px">
    <div v-if="!wxBoll">
      <wxlogin class="wxComponents" :appid="appid" :scope="scope" :redirect_uri="redirect_uri" state="001" theme="white"></wxlogin>
      <div @click="wxBoll = true" class="loginText">密码登录</div>
    </div>
    <el-form v-if="wxBoll" :model="ruleForm" :label-position="labelPosition"  :rules="rules" ref="ruleForm" label-width="50px">
      <el-form-item prop="name" >
        <el-input class="input" v-model="ruleForm.name" placeholder="登录名">
           <i slot="prefix" class="el-input__icon el-icon-message"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="pswd">
        <el-input class="input" v-model="ruleForm.pswd" type="password" placeholder="密码">
          <i slot="prefix" class="el-input__icon el-icon-goods"></i>
        </el-input>
      </el-form-item>
      <el-form-item>
        <!-- <div class="pawd" @click="dialogFormVisible = true">忘记密码</div> -->
      </el-form-item>
      <el-form-item>
        <div type="primary" class="btnLogin" @click="submitForm('ruleForm')">登录</div>
        <div class="rowText"></div>
        <!-- 微信登录按钮 -->
        <div class="wxLogin">
          <div class="wxBtn" @click="wxBoll = false"></div>
        </div>
      </el-form-item>
    </el-form>
    <el-dialog title="密码重置" :visible.sync="dialogFormVisible" width="400px" @close="_close">
      <el-form :model="form" status-icon :rules="formFules" ref="form">
        <div v-if="dialogShow === true">
          <el-form-item prop="name" label-width="50px">
          <el-input v-model="form.name" placeholder="登录名">
            <i slot="prefix" class="el-input__icon el-icon-message"></i>
          </el-input>
        </el-form-item>
        <!-- <el-form-item  prop="securityCode" label-width="50px">
          <el-input style="width:110px; vertical-align:bottom" v-model="form.securityCode" placeholder="验证码"></el-input>
          <div v-if="codeShow === true" class="btnCord" @click="btnCord"></div>
          <div style="display:inline-block" v-if="codeShow === false">{{countDown}}秒后重新获取</div>
          <i style="color:red">{{mistake}}</i>
        </el-form-item> -->
        <el-form-item label-width="40px">
        </el-form-item>
        </div>
        <div v-if="dialogShow === false">
          <el-form-item label="密码" prop="pswd" label-width="80px">
          <el-input v-model="form.pswd" type="password"></el-input>
        </el-form-item>
        <el-form-item></el-form-item>
        <el-form-item label="确认密码" prop="checkPass" label-width="80px">
          <el-input v-model="form.checkPass" type="password"></el-input>
        </el-form-item>
        </div>
      </el-form>
      <el-button @click="cancel">取 消</el-button>
      <el-button v-if="dialogShow === true" type="primary" @click="nextStep">下一步</el-button>
      <el-button v-if="dialogShow === false" @click="submit('form')">确 认</el-button>
    </el-dialog>
  </div>
</template>
<script>
import wxlogin from 'vue-wxlogin'
import * as req from '@/utils/request'
export default {
  data () {
    let validateName = (rule, value, callback) => {
      if (!this.repetition) {
        callback(new Error('用户名不存在'))
      } else {
        callback()
      }
    }
    let validateCheckPass = (rule, value, callback) => {
      if (value !== this.form.pswd) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    let validatePswd = (rule, value, callback) => {
      this.$refs.form.validateField('checkPass')
      callback()
    }
    return {
      // 微信登录
      wxBoll: true,
      appid: 'wx76d5d525ed5a7cd4',
      // redirect_uri: 'http%3a%2f%2fwww.xmhgapi.com',
      redirect_uri: 'http%3a%2f%2fwww.xmhgapi.com%2fmain',
      response_type: '1008611',
      scope: 'snsapi_login',
      labelPosition: 'right',
      // 显示重置密码块
      dialogShow: true,
      // 显示重置密码界面
      dialogFormVisible: false,
      // 忘记密码下一步错误信息
      mistake: '',
      // 验证登录名是否存在
      repetition: false,
      form: {
        name: '',
        pswd: '',
        checkPass: ''
      },
      formFules: {
        name: [
          {required: true, message: '登录名不能为空', trigger: 'blur'},
          { validator: validateName, trigger: 'blur' }
        ],
        pswd: [
          {required: true, message: '请输入密码', trigger: ['blur', 'change']},
          { min: 6, max: 18, message: '长度在 6 到 18 个字符', trigger: ['blur', 'change'] },
          { validator: validatePswd, trigger: ['blur', 'change'] }
        ],
        checkPass: [
          {required: true, message: '请再次输入密码', trigger: 'blur'},
          {validator: validateCheckPass, trigger: 'blur'}
        ]
      },
      ruleForm: {
        name: '',
        pswd: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入登录名', trigger: 'blur'}
        ],
        pswd: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    formName () {
      return this.form.name
    }
  },
  components: {
    wxlogin
  },
  watch: {
    formName (val, set) {
      this.verify()
    }
  },
  methods: {
    // 忘记密码取消
    cancel () {
      this.dialogFormVisible = false
      this.dialogShow = true
    },
    // 登录名是否存在
    verify () {
      let sendData = {}
      let obj = {}
      let filter = {}
      filter.logName = this.form.name
      obj.filter = filter
      sendData.data = obj
      sendData.fn = this.verifyCallBack
      sendData.vm = this
      req.Post('web/get_userinfo', sendData)
    },
    verifyCallBack (data) {
      if (data === null) {
        alert('服务器未连接')
        this.repetition = false
        return
      }
      if (data.err_code === 0) {
        this.repetition = true
        return
      }
      this.repetition = false
    },
    // 忘记密码下一步
    nextStep () {
      if (!this.repetition) {
        return
      }
      this.mistake = ''
      this.dialogShow = false
    },
    // 忘记密码下一步回调
    nextStepCallBack (data) {
      if (data === null) {
        alert('与服务器未连接')
        this.mistake('与服务器未连接')
        return
      }
      if (data.err_code !== 0) {
        this.mistake = data.err_msg
        return
      }
      this.mistake = ''
      this.dialogShow = false
    },
    // 重置密码确认
    submit (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let sendData = {}
          let obj = {}
          obj.log_name = _this.form.name
          obj.update = {
            pwd: _this.form.checkPass
          }
          sendData.data = obj
          sendData.fn = _this.submitBack
          sendData.vm = _this
          req.Post('web/edit_userinfo', sendData)
        }
      })
    },
    submitBack (data) {
      if (data === null) {
        alert('服务器未连接')
        return
      }
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      alert('修改成功')
      this._close()
    },
    // 退出忘记密码界面
    _close () {
      this.dialogFormVisible = false
      this.$refs['form'].resetFields()
      this.dialogShow = true
    },
    // 清空
    _empty () {
      this.$refs['ruleForm'].resetFields()
    },
    // 登录
    submitForm (data) {
      if (data === 'wx') {
        return
      }
      let _this = this
      this.$refs[data].validate((valid) => {
        if (valid) {
          let sendData = {}
          let obj = {}
          let pwd = this.$md5(_this.ruleForm.pswd)
          obj.log_name = _this.ruleForm.name
          obj.pwd = pwd
          obj.client = 'web'
          sendData.data = obj
          sendData.fn = _this.submitCallBack
          sendData.vm = _this
          req.Post('web/login', sendData)
        }
      })
    },
    // 登录回调
    submitCallBack (data) {
      if (data === null) {
        alert('服务器未连接')
        return
      }
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      let token = data.token
      window.localStorage.myToken = token
      window.location.href = 'http://www.xmhgapi.com/main?token:' + token + '@hg'
      // window.location.href = 'http://www.xmhgapi.com:7777/main?token:' + token + '@hg'
      // window.location.href = 'http://192.168.0.114/main'
      // window.location.href = 'http://localhost:8081?token:' + token
      // 清空
      this._empty()
    }
  }
}
</script>
<style scoped>
.img{
  background: url('../assets/btn/邮箱.png')
}
.input{
  width: 403px;
  /* background: #ededed; */
  background-color: rgba(0, 0, 0, 0.4) !important;
  margin:30px 0 0 0;
}
.el-form-item__error{
  left: 50px !important;
}
.pawd {
  margin-left:300px;
  width: 60px;
  text-decoration:underline;
  color: #5c6df9;
  text-align: right;
  padding-right: 100px;
  cursor: pointer;
}
.pawd:hover{
  color: red;
}
.btnLogin{
  width: 262px;
  height: 40px;
  background-color: #259cbf;
  /* background: url(../assets/btn/登录正常.png); */
  cursor: pointer;
  margin: 10px 0 0 40px;
  border-radius: 10px;
  color: white;
  font-size: 23px;
  text-align: center;
  line-height: 1.8;
  margin-left: 68px;
  box-shadow: 4px 5px 10px 5px rgb(189, 231, 243);
}
.btnLogin:hover{
  /* background: url('../assets/btn/登录悬浮.png') */
  background-color: #259bbf9f;
}
.btnCord{
  width: 179px;
  height: 70px;
  display: inline-block;
  background: url('../assets/btn/获取验证码正常.png');
  cursor: pointer;
  vertical-align:bottom;
  position: relative;
  top: 15px;
}
.btnCord:hover{
  background: url('../assets/btn/获取验证码悬浮.png');
}
/* 微信登录二维码 */
.wxComponents{
  margin-left: 110px;
}
.loginText{
  text-align: center;
  font-size: 14px;
  cursor:pointer;
  color: white;
}
.wxLogin{
  margin-top: 20px;
}
.wxBtn{
  width: 50px;
  height: 50px;
  background-image: url('../assets/logo1.png');
  background-size: 100% 100%;
  cursor:pointer;
}
.wxBtn:hover{
  background-image: url('../assets/logo2.png');
  background-size: 100% 100%;
}
.rowText{
  margin-top: 30px;
  width: 367px;
  height: 12px;
  background-image: url('../assets/rowText.png');
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/hgLogin1.vue